import usersReducer from './users';
export * from './users';

export default { users: usersReducer };
